module.exports = __webpack_public_path__ + "img/Sul.f365b45e.png";